import { cva } from 'class-variance-authority';

export const contentStyles = cva([
  'flex',
  'flex-col-reverse',
  'gap-8',
  'xl:grid',
  'xl:grid-cols-[310px_1fr]',
  'xl:gap-[104px]',
]);

export const sidebarStyles = cva(['flex', 'flex-col', 'gap-8', 'xl:gap-10']);

export const richTextStyles = cva([
  'flex',
  'flex-col',
  '[&>li]:text-lg',
  '[&>ol]:text-lg',
  '[&>ul]:text-lg',
  '[&>ul]:text-gray-700',
  '[&>p]:text-lg',
  '[&>p]:text-gray-700',
  '[&>section]:bg-[#F4FBF8]',
  '[&>section>div]:p-[32px]',
]);

export const resourceSectionStyles = cva([
  'relative',
  'my-0',
  'mx-auto',
  'px-4',
  'pt-12',
  'md:py-8',
  'md:px-8',
  'md:max-w-md',
  'lg:py-0',
  'lg:max-w-xl',
]);

export const resourceContentStyles = cva(['flex', 'flex-row-reverse', 'gap-8']);

export const resourceSidebar = cva(
  ['relative', 'w-full', 'lg:absolute', 'lg:right-[32px]', 'lg:top-[-370px]', 'lg:z-10', 'lg:h-fit', 'lg:w-[380px]'],
  {
    variants: {
      guideWithKicker: {
        true: ['lg:top-[-295px]'],
        false: [],
      },
      guideWithoutKicker: {
        true: ['lg:top-[-175px]'],
        false: [],
      },
    },
  },
);
